// Resolves which element an image drop (or Replace action) should land on, and
// the update patch to apply. Centralizes the Canva-style rule that dropping an
// image over a frame, a plain image, a clipped image, or a clipping-mask host
// replaces the underlying photo in place — never creating a new element.

// Returns { targetId, kind } or null when the element can't receive an image.
//   kind: 'frame' | 'plainImage' | 'clippedImage'
export function resolveImageReplaceTarget(element, elements) {
  if (!element) return null;

  if (element.type === 'frame') {
    return { targetId: element.id, kind: 'frame' };
  }

  // Clipping-mask host shape → route to its first clipped image child.
  if (element.type === 'shape' && (element.isMaskShape || element.isClipBase)) {
    const childIds = element.maskChildIds
      || (element.maskChildId ? [element.maskChildId] : [])
        .concat(element.clipChildId ? [element.clipChildId] : []);
    const ids = Array.isArray(childIds) ? childIds : [];
    const child = (elements || []).find((e) => ids.includes(e.id) && e.type === 'image');
    return child ? { targetId: child.id, kind: 'clippedImage' } : null;
  }

  if (element.type === 'image') {
    return element.clippedTo
      ? { targetId: element.id, kind: 'clippedImage' }
      : { targetId: element.id, kind: 'plainImage' };
  }

  return null;
}

// The update patch for a resolved target. Frames re-cover; plain images reset
// crop; clipped images swap src only so crop + mask geometry are preserved.
export function buildReplacePatch(kind, src) {
  switch (kind) {
    case 'frame':
      return { image: { src, offsetX: 0, offsetY: 0, scale: 1, rotation: 0 } };
    case 'clippedImage':
      return { src };
    case 'plainImage':
    default:
      return {
        src,
        cropOffsetX: 0, cropOffsetY: 0, cropScale: 1, cropRotation: 0,
        naturalWidth: null, naturalHeight: null,
      };
  }
}
